<template>
<div class="col-md-3">
  <div v-if="media">
    <div class="thumbnail">
      <a :href="media.filepath" target="_blank" title="Otwórz w nowym oknie">
        <img :src="media.filepath">
      </a>
      <div class="caption">
        <div style="margin-bottom: 10px;">
          {{ media.filename }}
        </div>
        <div style="overflow: hidden">
          <button class="btn btn-default pull-left" type="button" @click="$emit('change')">Zmień</button>
          <button class="btn btn-danger pull-right" type="button" @click="$emit('delete', media)">Usuń</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  props: {
    media: {required: true}
  }
}
</script>



// WEBPACK FOOTER //
// MediaItem.vue?1a7ed969